import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

export default function IconWithTooltip({
  icon,
  text,
  onClick,
  variant = "light",
  className = "",
  disabled = false,
}) {
  const renderTooltip = (props) => (
    <Tooltip
      id={`tooltip-${text ? text.replace(/\s+/g, "-").toLowerCase() : 'icon'}`}
      {...props}
    >
      {text}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <Button
        variant={variant}
        className={`rounded-circle p-0 d-flex align-items-center justify-content-center ${className} mx-1`}
        style={{ width: "32px", height: "32px" }}
        onClick={onClick}
        disabled={disabled}
      >
        <i className={`bi ${icon}`}></i>
      </Button>
    </OverlayTrigger>
  );
}
